import { stringify } from 'query-string';
import * as R from 'ramda';

const apiUrl = process.env.REACT_APP_BACKEND_HOST;

const zoomSessionsProvider = {
  getManyReference: async (params) => {
    const page = params.pagination.page;
    const limit = params.pagination.perPage;
    const sortPrefix =
      R.pathOr('ASC', ['sort', 'order'], params) === 'DESC' ? '-' : '';
    const sort = `${sortPrefix}${R.pathOr('id', ['sort', 'field'], params)}`;

    const options = {
      method: 'POST',
      body: JSON.stringify(params.search),
      headers: { 'Content-Type': 'application/json' },
    };

    const query = {
      page,
      limit,
      sort,
    };

    const url = `${apiUrl}/zoom_sessions/search?${stringify(query)}`;
    return { url, options };
  },
  getMany: async (params) => {
    const options = {
      method: 'POST',
      body: JSON.stringify({ _id: { $in: params.ids } }),
      headers: { 'Content-Type': 'application/json' },
    };
    const url = `${apiUrl}/zoom_sessions/search?${stringify({
      limit: params.ids.length,
    })}`;
    return { url, options };
  },
};

export default zoomSessionsProvider;
